$(document).ready(function () {
  
  $('.btn-subscribed').click(function(){
    	$.cookie("isSubscribed", 1, {
   			expires : 10,
	    	path    : '/',
		});
  });
  
  var isSubscribed = $.cookie("isSubscribed");

 /*if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
   setTimeout(function(){
      showSubscribePopup();
    }, 8000);
 } else { 
   $('body').on('mouseleave', function(e){
     if(e.clientY < 10){
       showSubscribePopup();       
     }
   });
 }*/
  
  function showSubscribePopup(){
    if((typeof isSubscribed === 'undefined') || !isSubscribed){
          var subscribeShown = $.cookie("subscribeShown");
          if((typeof subscribeShown === 'undefined') || !subscribeShown){
            $.cookie("subscribeShown", 1, {
              path    : '/',
            });
            $.fancybox.open({ 
              href: "#subscribe-popup",
              helpers : {
                overlay : {
                  css : {
                    'background' : 'rgba(128, 128, 128, 0.45)'
                  }
                }
              }
            });
          }
     }
   
  }

  $(".fancybox").fancybox({
    helpers : {
        overlay : {
            css : {
                'background' : 'rgba(128, 128, 128, 0.3)'
            	}
        	}
    	}
	}); 
});